import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from './useRedux'
import { authSelector, isFullyAuthenticatedSelector } from '@/pages/auth/selectors'

import { getProfile, setIsLoading } from '@/pages/user/userSlice'

export function useAuthSetup() {
  const { token } = useAppSelector(authSelector)
  const fullyAuthenticated = useAppSelector(isFullyAuthenticatedSelector)
  const dispatch = useAppDispatch()

  // The session is an HttpOnly cookie now — nothing to write client-side. `token` is only the
  // "is there a session?" marker; the profile fetch below is the de-facto session validation.

  // Always fetch a fresh profile on mount when FULLY authenticated, even if a stale user object was
  // rehydrated from localStorage by redux-persist. A session that still owes strong-MFA setup gets
  // no automatic traffic at all: the profile call would only 428 (it is what used to raise the
  // gate reactively, after the fact). The fetch fires once the requirement clears — App's gate
  // flips the flag on enrolment, which re-runs this effect — and a 200 authoritatively confirms it.
  useEffect(() => {
    if (fullyAuthenticated) {
      dispatch(getProfile())
    } else {
      dispatch(setIsLoading(false))
    }
  }, [token, fullyAuthenticated, dispatch])
}
